import { Component, Input, OnInit } from '@angular/core';
import { EUpdateMode } from 'apps/idl/src/modules/patients/model/eupdate-mode.enum';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { IUpdateHistory } from 'apps/idl/src/modules/patients/model/iupdate-history';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { PanneauService } from '../../../services/panneau.service';

@Component({
	selector: 'di-panneau-identite-patient',
	templateUrl: './panneau-identite-patient.component.html',
	styleUrls: ['./panneau-identite-patient.component.scss'],
})
export class PanneauIdentitePatientComponent implements OnInit {

	@Input()
	public patient: IPatient;

	public model: IPatient;

	constructor(private svcPatients: PatientsService, private svcPanneau: PanneauService) { }

	ngOnInit() { }

	public updatePatient = (patient: IPatient) => {

		this.model = patient;

		const loUpdateHistory: IUpdateHistory = {
			date: this.model.updateDate = new Date(),
			mode: this.model.updateMode = EUpdateMode.manual
		};
		this.model.updateHistory = [loUpdateHistory];
		this.svcPatients.savePatientAnakin(this.model).subscribe(() => {
			this.svcPatients.saveAdressCacheData(this.model);
			this.svcPanneau.close();
		})
	}
}
